import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  TextField,
  Alert
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

const FixedWingTwoPilot = ({ baseline, handleChange }) => {
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="h6">Two Pilot Operation (Para 6)</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Alert severity="info" sx={{ mb: 3 }}>
          <Typography variant="body2">
            Two pilot operation limits based on D7J-J4-Fixed Wing.pdf Para 6.1.1 and 6.1.2.
          </Typography>
        </Alert>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold' }}>Para 6.1.1: Max Flight Time = 8 hrs</Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Max FDP (5 Landings)"
              type="number"
              value={baseline.maxFDPTwoPilot8Hrs5Landings}
              onChange={(e) => handleChange('maxFDPTwoPilot8Hrs5Landings', parseFloat(e.target.value))}
              inputProps={{ min: 1, max: 14, step: 0.5 }}
              helperText="Para 6.1.1: 11:30 for 5 landings"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Max FDP (4 Landings)"
              type="number"
              value={baseline.maxFDPTwoPilot8Hrs4Landings}
              onChange={(e) => handleChange('maxFDPTwoPilot8Hrs4Landings', parseFloat(e.target.value))}
              inputProps={{ min: 1, max: 14, step: 0.5 }}
              helperText="Para 6.1.1: 12:00 for 4 landings"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Max FDP (3 Landings)"
              type="number"
              value={baseline.maxFDPTwoPilot8Hrs3Landings}
              onChange={(e) => handleChange('maxFDPTwoPilot8Hrs3Landings', parseFloat(e.target.value))}
              inputProps={{ min: 1, max: 14, step: 0.5 }}
              helperText="Para 6.1.1: 12:30 for 3 landings"
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ mt: 3, mb: 2, fontWeight: 'bold' }}>Para 6.1.2: Max Flight Time = 10 hrs</Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Max FDP (1/2 Landings)"
              type="number"
              value={baseline.maxFDPTwoPilot10Hrs}
              onChange={(e) => handleChange('maxFDPTwoPilot10Hrs', parseFloat(e.target.value))}
              inputProps={{ min: 1, max: 14, step: 0.5 }}
              helperText="Para 6.1.2: 13:30 for 1/2 landings"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Max Landings"
              type="number"
              value={baseline.maxLandingsTwoPilot10Hrs}
              onChange={(e) => handleChange('maxLandingsTwoPilot10Hrs', parseInt(e.target.value))}
              inputProps={{ min: 1, max: 5, step: 1 }}
              helperText="Para 6.1.2: 1/2 landings (rest increased for 2 landings)"
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default FixedWingTwoPilot;
